import { requestClient } from '../index';
import { parseResponse } from './requester';

const api = {
  signUrl: async (url: string) => {
    const response = await requestClient.post(
      'rental-manager-api/api/v1/multibrandSupport/googleMaps',
      { url },
      {
        params: { brandName: 'zillow' },
      },
    );
    return parseResponse(response);
  },
};

export default api;
